import { CellContext, createColumnHelper } from "@tanstack/react-table";
import React, { useState } from "react";
import { EnumEstadoProgramaAuditoria } from "../../../../entities/helper/EnumEstadoProgramaAuditoria";
import IPrograma from "../../../../entities/IPrograma";
import { shortDate } from "../../../../helpers/dateHelper";
import { ITipo_Campo } from "../../../../helpers/IFormHelper";
import { getAPI } from "../../../../helpers/httpHelper";
import { PathsAuditoria } from "../../../../helpers/pathDocumentsHelper";
import { usePromiseEffect } from "../../../../helpers/promiseEffect";
import {
  API_AUDITORIA,
  API_AUDITORIA_GETALL_HISTORICOPROGRAMASAUDITORIAS,
  API_AUDITORIA_GETALL_PROGRAMASAUDITORIAS,
  ROW_COUNT,
} from "../../../../helpers/variableHelper";
import AuditoriaService from "../../../../services/AuditoriaService";
import AdminLista from "../../../administration/AdminLista";
import { cognitoUserInfo } from "../../../../helpers/userHelper";
import ICurrentUser from "../../../../entities/helper/ICurrentUser";
import Loading from "../../../../cross/Loading";
import RenderTitle from "../../../../controls/RenderTitle";
import RenderValue from "../../../../controls/RenderValue";

interface IProgramasProps {
  token: string;
  isHistorico: boolean;
  items?: Array<any>;
  loading?: boolean;
}
export default function Programas({ token, isHistorico, items, loading }: IProgramasProps) {
  const [isLoading, setIsLoading] = useState(false);

  const [pages, setPages] = useState(0);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(ROW_COUNT);
  const [listItems, setListItems] = useState<Array<any>>([]);
  const [filtersState, setFilters] = useState<any>();
  const [currentUser, setCurrentUser] = useState<ICurrentUser>();
  const [isDownloading, setIsDownloading] = useState(false);

  const refTxtAnio = React.createRef<HTMLInputElement>();
  const component = (titulo: string) => {
    return <RenderTitle title={titulo} />;
  };

  const componentValue = (value: any) => {
    return <RenderValue value={value} />;
  };

  const componentArchivo = (value: any) => {
    if (value.row.original.ID_ESTADO == EnumEstadoProgramaAuditoria.ProgramaAprobado) {
      return (
        <i
          className="bi bi-file-earmark-arrow-down-fill iconDescarga"
          onClick={async () => {
            const path = PathsAuditoria.ProgramaAuditoriaPath(value.row.original.ID);
            setIsDownloading(true);
            let flag = await AuditoriaService.GetContenidoArchivo(token, path);
            if (!flag) {
              await AuditoriaService.GenerarPDFPrograma(token, value.row.original.ID);
              await AuditoriaService.GetContenidoArchivo(token, path);
            }
            setIsDownloading(false);
          }}></i>
      );
    }
  };

  const renderOpciones = (value: any) => {
    return (
      <a className="text-decoration-none" href={`detalleprograma?id=${value.ID}`}>
        <i className="bi bi-pencil-square iconPencil"></i>
      </a>
    );
  };

  usePromiseEffect(async () => {
    let currUser = await cognitoUserInfo();
    setCurrentUser(currUser);
    setIsLoading(false);
  }, []);
  const paging = (page: any) => {
    setPage(page);
    filter({ PAGINA: page }, true);
  };
  const filter = async (filter: Partial<IPrograma>, page: boolean = false, size = pageSize, isClickBuscar = false) => {
    setIsLoading(true);
    if (!filter) {
      filter = {};
    }
    filter.ANIO = isClickBuscar ? parseInt(refTxtAnio.current?.value || "") || null : filter.ANIO;
    filter.PAGINADO = size;
    if (filter.PAGINA === undefined) {
      filter.PAGINA = 1;
    }
    if (!page) {
      filter.PAGINA = 1;
    }
    setPage(filter.PAGINA);

    if (filter.ORDENADOPOR === undefined) {
      filter.ORDENADOPOR = "ID";
      filter.ORIENTACION = "DESC";
    }
    let result = await getAPI(
      isHistorico
        ? `${API_AUDITORIA}${API_AUDITORIA_GETALL_HISTORICOPROGRAMASAUDITORIAS}`
        : `${API_AUDITORIA}${API_AUDITORIA_GETALL_PROGRAMASAUDITORIAS}`,
      { Authorization: `Bearer ${token}` },
      filter
    );
    let data = result.result !== undefined ? result.result.data : items;
    setListItems(data);
    let pages = result.result !== undefined ? result.result.pages : 1;
    setPages(pages);
    setFilters(filter);
    setIsLoading(false);
  };

  const columnHelperMantIncCausa = createColumnHelper<IPrograma>();
  let columnsDef = [
    columnHelperMantIncCausa.accessor((row) => row.CORRELATIVO, {
      id: "CORRELATIVO",
      cell: (info: CellContext<IPrograma, string>) => componentValue(info.getValue()),
      header: () => component("Código Programa"),
    } as any),
    columnHelperMantIncCausa.accessor((row) => row.ESTADO, {
      id: "ESTADO_PROGRAMA",
      cell: (info: CellContext<IPrograma, string>) => componentValue(info.getValue()),
      header: () => component("Estado Programa"),
      title: "Estado Programa",
    } as any),
    columnHelperMantIncCausa.accessor((row) => row.NOMBRE, {
      id: "PROGRAMA",
      cell: (info: CellContext<IPrograma, string>) => componentValue(info.getValue()),
      header: () => component("Nombre Programa"),
    } as any),
    columnHelperMantIncCausa.accessor((row) => row.ANIO, {
      id: "ANIO",
      cell: (info: CellContext<IPrograma, string>) => componentValue(info.getValue()),
      header: () => component("Año"),
      title: "Año",
    } as any),
    columnHelperMantIncCausa.accessor((row) => row.FECHA_APROBACION, {
      id: "FECHA_APROBACION",
      cell: (info: CellContext<IPrograma, string>) => componentValue(shortDate(info.getValue())),
      header: () => component("Fecha Aprobación"),
      tipo: ITipo_Campo.date,
    } as any),
    columnHelperMantIncCausa.accessor((row) => row.CORRELATIVO, {
      id: "ARCHIVO",
      cell: (
        info: CellContext<IPrograma, string> //
      ) => componentArchivo(info),
      header: () => component("Archivo"),
      disableSorting: true,
    } as any),
    columnHelperMantIncCausa.accessor((row) => row.CORRELATIVO, {
      id: "OPCIONES",
      cell: (info: CellContext<IPrograma, string>) => renderOpciones(info.row.original),
      header: () => component("Opciones"),
      disableSorting: true,
      hide: !currentUser?.roles.IS_ADMIN && !currentUser?.roles.IS_ADMIN_AUDITORIA,
    } as any),
  ] as any;
  return (
    <div>
      {isDownloading && <Loading key="loadingDownload" cssContainer="loadingFlotante" />}
      <div className="card bg-light border p-3 pt-2 mt-2">
        <button
          hidden={true}
          data-testid="test1"
          onClick={() => {
            paging(1);
          }}></button>
        <div className="row ajusteInput">
          <div className="col-12 pt-0">
            <label className="text-sm">Buscar año</label>
          </div>

          <div className="col-sm-12 col-md-6 col-lg-3 pt-0">
            <input
              className="form-control form-control-sm"
              type="number"
              max={new Date().getFullYear()}
              min={1950}
              placeholder="Indique el año"
              ref={refTxtAnio}
            />
          </div>

          <div className="col-sm-12 col-md-8 col-lg-8">
            <button
              type="button"
              className="btn btn-sm btn-primary me-2"
              onClick={() => {
                filter(filtersState, false, pageSize, true);
              }}>
              {" "}
              <i className="bi bi-search me-2"></i> Buscar
            </button>
            <button
              type="button"
              className="btn btn-sm btn-outline-secondary me-2"
              onClick={() => {
                (refTxtAnio.current as HTMLInputElement).value = "";
                filter({ ...filtersState, ANIO: null });
              }}>
              {" "}
              <i className="bi bi-trash me-2"></i>Limpiar
            </button>
            {(currentUser?.roles.IS_ADMIN || currentUser?.roles.IS_ADMIN_AUDITORIA) && (
              <button
                type="button"
                className="btn btn-sm btn-outline-primary"
                onClick={() => {
                  window.location.href = "agregarprograma";
                }}>
                {" "}
                <i className="bi bi-plus-circle me-2"></i>Crear Programa Auditoría
              </button>
            )}
          </div>
          <div className="col-sm-12 col-md-4 col-lg-4 pt-0 d-grid gap-2 d-md-flex justify-content-md-end"></div>
        </div>
      </div>

      <div className="" id="collapseGeneradas">
        <div className="card card-body border-0 p-0 mt-2">
          <div className="row">
            <div className="col-12">
              <div className="container-fluid mb-4">
                <h1 className="titPrincipal colorTit mt-2">Generadas</h1>

                <div className="row">
                  <div className="col-12 p-1">
                    <AdminLista
                      hideAdd={true}
                      hideExport={true}
                      data={listItems}
                      callback={() => {}}
                      reload={filter}
                      filter={filter}
                      pagination={{
                        pages: pages,
                        page: page,
                        paging: paging,
                      }}
                      tipo="Programaciones"
                      columnsDef={columnsDef}
                      isLoading={isLoading}
                      callbackUpdatePageSize={(pageSize: number, filters: Object) => {
                        setPageSize(pageSize);
                        filter(filters, false, pageSize);
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
